export default "__VITE_ASSET__D$JBudMk__"